import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthContainerComponent } from './auth-container.component';
import { LoginComponent } from './components/login/login.component';
import { ForgotPasswordComponent } from './components/forgotPassword/forgot-password.component';
import { ChangePasswordComponent } from './components/changePassword/change-password.component';
import { UpdateForgotPasswordComponent } from './components/updateForgotPassword/update-forgot-password.component';
import { EcmAuthgaurdGuard } from 'src/app/middleware/authentication/authgaurd/ecm-authgaurd.guard';
import { UserRegistrationInviteComponent } from './components/UserRegistrationInvite/UserRegistrationInvite.component';
import { PortalLoginComponent } from './components/PortalLogin/PortalLogin.component';
import { VerifyIPComponent } from './components/VerifyIP/VerifyIP.component';


const routes: Routes = [
  {
    path: '',
    component: AuthContainerComponent,
    children: [
      {
        path: 'login',
        component: LoginComponent
      },
      {
        path: 'portallogin',
        component: PortalLoginComponent
      },
      {
        path: 'verifyip',
        component: VerifyIPComponent
      },
      {
        path: 'UserRegistrationInvite',
        component: UserRegistrationInviteComponent
      },
      {
        path: 'forgotPassword',
        component: ForgotPasswordComponent
      },
        {
          path: 'resetPassword',
          component: ChangePasswordComponent,
          canActivate: [EcmAuthgaurdGuard]
        },
        {
          path: 'updatePassword',
          component: UpdateForgotPasswordComponent
        }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthRoutingModule { }
